import { u as t } from "../index-CmJY5ZEp.js";
const s = () => {
  const i = t("(min-width: 1280px)"), n = t("(max-width: 600px)"), o = t(
    "(min-width: 601px) and (max-width: 1279px)"
  ), a = t(
    "(min-width: 601px) and (max-width: 1279px) and (orientation: portrait)"
  );
  return {
    /** returns Larger screen tablets [min-width: 1280px] */
    isDesktop: i,
    /**  returns Smaller screen tablets [max-width: 600px] */
    isMobile: n,
    /** returns Larger screen phones and smaller screen desktop [min-width: 601px and max-width: 1279px] */
    isTablet: o,
    /** returns tablet screen with portrait orientation [min-width: 601px and max-width: 1279px and orientation: portrait] */
    isTabletPortrait: a
  };
};
export {
  s as useDevice
};
